import { useGetOne } from 'react-admin';

export const CUSTOMER_QUERY = 'customers';

export function useCustomer(customerId) {
  //to-do: implement select when we upgrade to react admin 4.0
  return useGetOne(CUSTOMER_QUERY, { id: customerId }, { enabled: !!customerId });
}
